<ag-grid-angular style="width: 100%;" [rowData]="rows" [columnDefs]="colDefs" (rowClicked)="onRowClicked($event)"
                 [modules]="modules" [theme]="theme" [domLayout]="'autoHeight'" [suppressCellFocus]="true"
                 [gridOptions]="gridOptions" (sortChanged)="onSortChanged($event)"></ag-grid-angular>
